"use client"

import { useQuery } from "@tanstack/react-query"

import { galleryImages } from "@/lib/helpers/product-images"
import { catalogGateway } from "@/platform/api/gateways/catalog"
import { useGateway } from "@/platform/session/use-api"

export const useProductGallery = (productId: string | null, enabled: boolean) => {
  const catalog = useGateway(catalogGateway)
  return useQuery({
    queryKey: ["referrals", "product-gallery", productId],
    queryFn: async () => galleryImages(await catalog.product({ id: productId ?? "", publicOnly: true })),
    enabled: enabled && productId !== null,
    staleTime: 5 * 60_000,
    retry: false,
  })
}
